import PropTypes from 'prop-types'
import React from 'react'
import {Helmet} from 'react-helmet'

const BreadcrumbScemaMarkup = ({product}) => {
    const c_breadcrumbs = Array.isArray(product?.c_breadcrumbs) ? product?.c_breadcrumbs : []
    const slugUrl = product?.slugUrl || ''
    const name = product?.name || ''

    const breadcrumbList = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
            ...c_breadcrumbs.map((crumb, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: crumb.htmlValue,
                item: crumb.url
            })),
            {
                '@type': 'ListItem',
                position: c_breadcrumbs.length + 1,
                name,
                item: slugUrl
            }
        ]
    }

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(breadcrumbList)}</script>
        </Helmet>
    )
}

BreadcrumbScemaMarkup.propTypes = {
    product: PropTypes.shape({
        c_breadcrumbs: PropTypes.array,
        slugUrl: PropTypes.string,
        name: PropTypes.string
    })
}

export default BreadcrumbScemaMarkup
